import whichEnv from '@ally/which-env'
import { AccountStatus } from '@ally/data-types-afg-accounts'

const env = whichEnv(window.location.href)

// -------------------------------------------------------------------------- //
// Apigee sts endpoint api keys
// -------------------------------------------------------------------------- //
export const apigeeAPIKey = env.pick({
  dev: 'wU5VdAI4fv7jgsaAOJDREixc3MOaUs1R',
  cap: 'BdWWhZRHCmdNq74CJYfaozM2gZCZqEDs',
  fix: 'BdWWhZRHCmdNq74CJYfaozM2gZCZqEDs',
  qa1: 'BdWWhZRHCmdNq74CJYfaozM2gZCZqEDs',
  qa2: 'BdWWhZRHCmdNq74CJYfaozM2gZCZqEDs',
  qa3: 'BdWWhZRHCmdNq74CJYfaozM2gZCZqEDs',
  prod: 'XhnbsDYmBensf2vqVXAfv0uD7SJBA27u',
  local: 'wU5VdAI4fv7jgsaAOJDREixc3MOaUs1R',
})

// -------------------------------------------------------------------------- //
// SAML CardWords URL
// -------------------------------------------------------------------------- //
export const cardWorksSamlBaseUrl = env.pick({
  dev: 'https://uat.card.ally.com/xconnect/SSO',
  cap: 'https://uat.card.ally.com/xconnect/SSO',
  fix: 'https://uat.card.ally.com/xconnect/SSO',
  qa1: 'https://uat.card.ally.com/xconnect/SSO',
  qa2: 'https://uat.card.ally.com/xconnect/SSO',
  qa3: 'https://uat.card.ally.com/xconnect/SSO',
  prod: 'https://card.ally.com/xconnect/SSO',
  local: 'https://uat.card.ally.com/xconnect/SSO',
})

// -------------------------------------------------------------------------- //
// LAPI GraphQL endpoint
// -------------------------------------------------------------------------- //
export const LAPI_ENDPOINT = '/acs/v1/lending/graphql'

// -------------------------------------------------------------------------- //
// Card Works SSO Prefix
// -------------------------------------------------------------------------- //
export const CC_PREFIX = '/sso/credit-card/'

// -------------------------------------------------------------------------- //
// Invalid Credit Card Statuses - if an account has one of these, it is not valid to SSO
// -------------------------------------------------------------------------- //
export const invalidCardStatuses = [
  AccountStatus.BANKRUPT,
  AccountStatus.CHARGED_OFF,
  AccountStatus.FROZEN_OR_FRAUD,
  AccountStatus.LOST,
  AccountStatus.STOLEN,
]

// -------------------------------------------------------------------------- //
// Auto Environment URLs
// -------------------------------------------------------------------------- //
export const autoBaseUrl = env.pick({
  local: 'https://secureauto-cit2.ally.com',
  dev: 'https://secureauto-cit2.ally.com',
  qa1: 'https://secureauto-uat2.ally.com',
  qa2: 'https://secureauto-uat2.ally.com',
  qa3: 'https://secureauto-uat2.ally.com',
  cap: 'https://secureauto-cap.ally.com',
  fix: 'https://secureauto-fix.ally.com',
  psp: 'https://secureauto-prodsupt.ally.com',
  prod: 'https://secureauto.ally.com',
})
